export default "__VITE_ASSET__CiTzHO7H__"